export default __webpack_public_path__ + "static/media/art-brw-1.9bc84bbf.png";